import {addGitHubToTitle, setTitle} from '@github-ui/document-metadata'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useMatches, useParams} from '@github-ui/react-router'
import {AnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepositoryProjectsPage as RepositoryProjectsPageContent} from '@github-ui/repository-projects'
import {useEffect} from 'react'

import {issuesLayoutRoute} from './issues-layout-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function RepositoryProjectsPage() {
  const {owner = '', repo = ''} = useParams<{owner: string; repo: string}>()
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const renderSidebar = useRenderSidebar(owner, repo, layoutPayload)
  const matches = useMatches()
  const title = `Projects · ${owner}/${repo}`

  useEffect(() => {
    // These routes have no mainQuery, so whenever the matches change, TitleManager falls back to the Issues
    // layout's title (just "Issues" after a soft navigation). Replace it once TitleManager's effect has run.
    const timeoutId = setTimeout(() => setTitle(addGitHubToTitle(title)), 0)
    return () => clearTimeout(timeoutId)
  }, [matches, title])

  return (
    <AnalyticsWrapper category="Repository Projects Index" appName="issues">
      <RepositoryProjectsPageContent renderSidebar={renderSidebar} initialExpanded={layoutPayload?.sidebarExpanded} />
    </AnalyticsWrapper>
  )
}
